import { render, staticRenderFns } from "./RBarChart.vue?vue&type=template&id=e94ccd16&scoped=true&"
import script from "./RBarChart.vue?vue&type=script&lang=js&"
export * from "./RBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94ccd16",
  null
  
)

export default component.exports